var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import cx from 'classnames';
import { getCellStyle } from './utils';
import { SubRowExpander } from './SubRowExpander';
import { SELECTION_CELL_ID } from './columns';
import { DefaultCell } from './cells';
export var TableCell = function (props) {
    var cell = props.cell, cellIndex = props.cellIndex, isDisabled = props.isDisabled, tableHasSubRows = props.tableHasSubRows, tableInstance = props.tableInstance, expanderCell = props.expanderCell;
    var hasSubRowExpander = cellIndex ===
        cell.row.cells.findIndex(function (c) { return c.column.id !== SELECTION_CELL_ID; });
    var getSubRowStyle = function () {
        if (!tableHasSubRows || !hasSubRowExpander) {
            return undefined;
        }
        // If it doesn't have sub-rows then shift by another level to align with expandable rows on the same depth
        // 16 = initial_cell_padding, 35 = 27 + 8 = expander_width + margin
        return {
            paddingLeft: 16 + (cell.row.depth + (cell.row.canExpand ? 0 : 1)) * 35,
        };
    };
    var cellElementProps = cell.getCellProps({
        className: cx('iui-cell', cell.column.cellClassName),
        style: __assign(__assign({}, getCellStyle(cell.column, !!tableInstance.state.isTableResizing)), getSubRowStyle()),
    });
    var cellProps = __assign(__assign({}, tableInstance), { cell: cell, row: cell.row, value: cell.value, column: cell.column });
    var cellContent = (React.createElement(React.Fragment, null,
        tableHasSubRows && hasSubRowExpander && cell.row.canExpand && (React.createElement(SubRowExpander, { cell: cell, isDisabled: isDisabled, cellProps: cellProps, expanderCell: expanderCell })),
        cell.render('Cell')));
    var cellRendererProps = {
        cellElementProps: cellElementProps,
        cellProps: cellProps,
        children: cellContent,
    };
    return (React.createElement(React.Fragment, null, cell.column.cellRenderer ? (cell.column.cellRenderer(__assign(__assign({}, cellRendererProps), { isDisabled: function () { return isDisabled; } }))) : (React.createElement(DefaultCell, __assign({}, cellRendererProps, { isDisabled: function () { return isDisabled; } })))));
};
export default TableCell;
